import { authManager } from '../api-clients/whisperClient';
import { createApiRouter } from '../api/apiRouter';

export const API_CONFIG = {
  // Legacy API Gateway URL (for existing lambda endpoints)
  apiGatewayUrl: import.meta.env.VITE_API_GATEWAY_URL,

  // Ambient Scribe REST URL (used for API endpoints when migration is enabled)
  ambientScribeRestUrl: import.meta.env.VITE_WHISPER_REST_URL,

  auth: {
    apiKey: import.meta.env.VITE_API_KEY,

    region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  },

  defaults: {
    timeout: 30000,
    maxRetries: 3,
    retryDelayMs: 1000,
  },

  headers: {
    'Content-Type': 'application/json',
  },

  migration: {
    // Endpoints routed to the new service; use "*" to route all endpoints.
    newServiceEndpoints: ['*'],
  },
} as const;

export async function getAuthHeaders(): Promise<Record<string, string>> {
  const headers = {
    ...API_CONFIG.headers,
  };

  const token = await authManager.getToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
}

export const apiRouter = createApiRouter(
  API_CONFIG.apiGatewayUrl || '',
  API_CONFIG.ambientScribeRestUrl || '',
  [...API_CONFIG.migration.newServiceEndpoints], // Convert readonly array to mutable
  false // Router starts disabled; updateApiRouterForMigration applies the env-controlled setting.
);

/**
 * Update API router configuration based on environment variable
 * Environment variable controls migration routing directly
 */
export function updateApiRouterForMigration(): void {
  const migrationEnabled =
    import.meta.env.VITE_MIGRATE_API_SCRIBE_ENABLED === 'true';

  apiRouter.updateConfig({
    migrationEnabled,
  });
}
